import { useEffect, useState } from "react";
import { previewUrl } from "@/lib/image";

// Bir File için object URL üretir ve dosya değişince/bileşen kalkınca bırakır.
//
// Render içinde URL.createObjectURL çağırmak her karede bir blob sızdırıyor — bırakılacak referans
// hiçbir yerde tutulmadığı için sayfa yenilenene kadar bellekte kalıyorlar. Bu kancanın tamamı o
// hatayı bir kez çözmek için var (ImageUploadModal'da tam olarak bu haliyle duruyordu).
//
// previewUrl (lib/image) senkron değil: SVG'ler viewBox'tan boyut yamasından geçiyor. O yüzden
// `revoked` bayrağı gerekiyor — URL hazır olduğunda dosya çoktan değişmiş olabilir.
//
// `failed` ŞART: previewUrl reddedebiliyor (file.text() seçimden sonra taşınmış/silinmiş dosyada
// NotReadableError atıyor). Yakalanmazsa hem işlenmemiş promise reddi oluyor hem de arayüz sonsuza
// kadar boş bir kutuda kalıyor — kullanıcıya hiçbir şey söylemeden.
export function useObjectUrl(file) {
  const [state, setState] = useState({ url: null, failed: false });

  useEffect(() => {
    if (!file) {
      setState({ url: null, failed: false });

      return undefined;
    }

    let revoked = false;
    let created = null;

    previewUrl(file).then(
      (next) => {
        if (revoked) {
          URL.revokeObjectURL(next);

          return;
        }
        created = next;
        setState({ url: next, failed: false });
      },
      (error) => {
        console.warn("[panel] object url failed", error);

        if (!revoked) {
          setState({ url: null, failed: true });
        }
      },
    );

    return () => {
      revoked = true;
      setState({ url: null, failed: false });
      if (created) {
        URL.revokeObjectURL(created);
      }
    };
  }, [file]);

  return state;
}
